import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import AuthService from "../services/authService";
import "./Login.css";

export interface ILoginProps {
    signedIn: boolean;
}

const authService = new AuthService();

const Login: FunctionComponent<ILoginProps> = ({ signedIn }) => {
    const signOut = () => {
        authService.logout();
    };

    return (
        <div className="container">
            {signedIn ?
                // eslint-disable-next-line
                <a href="#" onClick={signOut} className="login-button">Sign out</a>
                :
                <Link to="/signin" className="login-button">Sign in</Link>
            }
        </div>
    );
};

export default Login;
